
// isBefore( claimob.status )
export const isBefore = ({code}) => { 
    return 'before' === code
}

export const isShould = ({code}) => { 
    return 'shouldfinish' === code
}

export const isReady = ({code}) => { 
    return 'ready' === code
}

export const isActive = ({code}) => { 
    return 'active' === code
}

export const ReplaceToMain = ({router, route}) => {
    let name = 'Start' === route.name ? 'StartNext' : 'Start'
    router.replace({name})
}
